var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-content",
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "", "justify-center": "" } },
            [
              _vm.screen_breakpoint
                ? _c(
                    "v-container",
                    {
                      staticClass: "title1",
                      attrs: {
                        "grid-list-lrg": "",
                        "display-2": "",
                        "text-md-center": "",
                        "text-xs-center": ""
                      }
                    },
                    [_vm._v("\n        Your Art, Your Way\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.screen_breakpoint
                ? _c(
                    "v-container",
                    {
                      staticClass: "title1",
                      attrs: {
                        "grid-list-lrg": "",
                        "display-2": "",
                        "text-md-center": "",
                        "text-xs-center": ""
                      }
                    },
                    [
                      _vm._v("\n        Your Art,"),
                      _c("br"),
                      _vm._v("Your Way\n      ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.screen_breakpoint
                ? _c(
                    "v-container",
                    {
                      staticClass: "title2",
                      attrs: {
                        "grid-list-lrg": "",
                        "font-wieght": "",
                        headline: "",
                        "text-md-center": "",
                        "text-xs-center": ""
                      }
                    },
                    [
                      _vm._v(
                        "\n      Welcome to Share Yourself Artists, the easiest way to share your"
                      ),
                      _c("br"),
                      _vm._v(
                        "artwork to millions of art lovers around the world!\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.screen_breakpoint
                ? _c(
                    "v-container",
                    {
                      staticClass: "title2",
                      attrs: {
                        "grid-list-lrg": "",
                        "font-wieght": "",
                        headline: "",
                        "text-md-center": "",
                        "text-xs-center": ""
                      }
                    },
                    [
                      _vm._v("\n      Welcome to Share Yourself"),
                      _c("br"),
                      _vm._v("Artists, the easiest way"),
                      _c("br"),
                      _vm._v("to share your artwork"),
                      _c("br"),
                      _vm._v(" to millions of art lovers"),
                      _c("br"),
                      _vm._v("around the world!\n    ")
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "account-btns", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "text-xs-center text-sm-right",
                  attrs: { xs12: "", sm6: "", "pl-3": "", "pr-3": "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { height: "35px", width: "175px" },
                      attrs: {
                        color: "black",
                        dark: "",
                        large: "",
                        depressed: "",
                        router: "",
                        to: "/business_signup"
                      }
                    },
                    [_vm._v("\n        BUSINESS SIGN UP\n      ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "text-xs-center text-sm-left",
                  attrs: { xs12: "", sm6: "", "pl-3": "", "pr-3": "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { height: "35px", width: "175px" },
                      attrs: {
                        color: "black",
                        dark: "",
                        large: "",
                        depressed: "",
                        router: "",
                        to: "/artist_signup"
                      }
                    },
                    [_vm._v("\n      ARTIST SIGN UP\n      ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.screen_breakpoint
            ? _c("img", {
                staticStyle: { width: "100vw" },
                attrs: { src: "/static/images/banner.png" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel1" },
            [
              _c(
                "v-container",
                { staticClass: "panel1" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-center",
                          staticStyle: {
                            color: "#FF7D27",
                            "font-size": "2.2em"
                          },
                          attrs: { xs12: "", sm12: "" }
                        },
                        [_c("p", [_c("strong", [_vm._v("Three easy steps")])])]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.icons, function(icon, index) {
                        return _c(
                          "v-flex",
                          {
                            key: icon.title,
                            attrs: {
                              "text-sm-left": "",
                              sm4: "",
                              xs12: "",
                              "pl-4": "",
                              "pr-4": "",
                              "mt-3": ""
                            }
                          },
                          [
                            _c(
                              "center",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "number-circles text-sm-center"
                                  },
                                  [
                                    _c(
                                      "h1",
                                      { staticStyle: { "font-size": "40px" } },
                                      [_vm._v(_vm._s(index + 1))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "2.2em" } },
                                  [_c("strong", [_vm._v(_vm._s(icon.title))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "iconRow",
                                    attrs: { color: "orange darken-2" }
                                  },
                                  [_vm._v(_vm._s(icon.icon))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "body-1 text-sm-left",
                                    staticStyle: {
                                      "font-size": "1.1em !important"
                                    }
                                  },
                                  [_vm._v(_vm._s(icon.text))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "textRow", attrs: { "grid-list-lg": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(_vm.texts, function(text) {
                      return _c(
                        "v-flex",
                        {
                          key: text.title,
                          attrs: { lg6: "", xs12: "", "pl-4": "", "pr-4": "" }
                        },
                        [
                          _c("p", { staticClass: "headline pl-2 pr-2" }, [
                            _c("strong", [_vm._v(_vm._s(text.title))])
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "body-1 pl-2 pr-2",
                              staticStyle: { "font-size": "1.1em !important" }
                            },
                            [_vm._v(_vm._s(text.body))]
                          )
                        ]
                      )
                    })
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 